export default __webpack_public_path__ + "static/jackson-USA-cc7e48aceb06ad9d749cb31a946c402f.jpg";